/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Filter_Last_MonthInputs */

const en_ui_filter_last_month = /** @type {(inputs: Ui_Filter_Last_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`last month`)
};

const de_ui_filter_last_month = /** @type {(inputs: Ui_Filter_Last_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`letzter Monat`)
};

/**
* | output |
* | --- |
* | "last month" |
*
* @param {Ui_Filter_Last_MonthInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_last_month = /** @type {((inputs?: Ui_Filter_Last_MonthInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_Last_MonthInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_last_month(inputs)
	return de_ui_filter_last_month(inputs)
});